// Read-only description of a measure's v2.7 filter context (Power BI
// CALCULATE filters / ALL / REMOVEFILTERS imported by
// POST /api/v1/admin/powerbi/import-model), shown next to the measure.

export interface MeasureFilterSpec {
  field: string;
  operator: string;
  value?: unknown;
  keepFilters?: boolean;
  valueFrom?: { field?: string; pick?: string; offset?: number; lookup?: string } | null;
}

export interface MeasureContextLike {
  aggregation?: string | null;
  source_field?: string | null;
  expression?: string | null;
  filters?: MeasureFilterSpec[] | null;
  ignore_filters?: string[] | null;
  source_dataset_id?: string | null;
  source_measure?: string | null;
}

const OPERATORS: Record<string, string> = {
  equals: "=",
  not_equals: "≠",
  in: "in",
  not_in: "not in",
  greater_than: ">",
  greater_than_or_equal: "≥",
  less_than: "<",
  less_than_or_equal: "≤",
};

function describeValue(f: MeasureFilterSpec): string {
  if (f.operator === "single_value") return "(one value selected)";
  if (f.valueFrom) {
    const pick = f.valueFrom.pick === "single" ? "selected" : f.valueFrom.pick ?? "";
    const offset = f.valueFrom.offset ? ` ${f.valueFrom.offset > 0 ? "+" : "−"} ${Math.abs(f.valueFrom.offset)}` : "";
    return `${pick} ${f.valueFrom.lookup ? `${f.valueFrom.lookup}.` : ""}${f.valueFrom.field ?? ""}${offset}`.trim();
  }
  return Array.isArray(f.value) ? `(${f.value.join(", ")})` : String(f.value ?? "");
}

/** "where Kind = Actual · ignoring Vessel" -- empty string when the measure has no context. */
export function describeMeasureContext(m: MeasureContextLike): string {
  const parts: string[] = [];
  if (m.source_measure) parts.push(`from a related table: ${m.source_measure}`);
  if (m.filters?.length) {
    parts.push(
      "where " +
        m.filters
          .map((f) => (f.operator === "single_value" ? `${f.field} has one value` : `${f.field} ${OPERATORS[f.operator] ?? f.operator} ${describeValue(f)}`))
          .join(", "),
    );
  }
  if (m.ignore_filters?.length) {
    parts.push(m.ignore_filters.includes("*") ? "ignoring all filters" : `ignoring ${m.ignore_filters.join(", ")}`);
  }
  return parts.join(" · ");
}
